import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import Divider from '@mui/material/Divider'
import Tooltip from '@mui/material/Tooltip'
import EditIcon from '@mui/icons-material/Edit'
import Box from '@mui/material/Box'
import { ListItemButton, colors, List } from '@mui/material'
import { stringAvatar } from '@assembly/utils'
import { SkillAssessment } from './types'
import AssessmentIcon from '@mui/icons-material/Assessment'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import React from 'react'

interface SkillAssessmentListProps {
  skillsAssessment: SkillAssessment[]
  onClickDelete: (skillsAssessments: SkillAssessment, index: number) => void
  onClickEdit: (skillsAssessments: SkillAssessment, index: number) => void
}

export default function SkillAssessmentList(props: SkillAssessmentListProps) {
  const height = window.innerHeight - 162
  const [tooltipStates, setTooltipStates] = React.useState<Record<string, string>>({})

  const copyToClipboard = (id: string, text: string) => {
    navigator.clipboard.writeText(text)
    setTooltipStates(prev => ({ ...prev, [id]: 'Copied!' }))
    setTimeout(() => {
      setTooltipStates(prev => ({ ...prev, [id]: 'Copy ID' }))
    }, 2000)
  }

  return (
    <List sx={{ height, overflow: 'auto' }}>
      {props.skillsAssessment.map((skillAssessment, index) => (
        <div key={index}>
          <ListItem
            sx={{ padding: 0 }}
            secondaryAction={
              <Box display="flex" gap={3}>
                <Tooltip
                  title={tooltipStates[skillAssessment.id] || 'Copy ID'}
                  sx={{ marginLeft: 1, color: colors.grey[800] }}
                >
                  <IconButton onClick={() => copyToClipboard(skillAssessment.id, skillAssessment.id)}>
                    <ContentCopyIcon sx={{ width: 20, height: 20 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => props.onClickEdit(skillAssessment, index)}
                    edge="end"
                    aria-label="edit"
                    sx={{ color: colors.grey[800] }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton
                    onClick={() => props.onClickDelete(skillAssessment, index)}
                    edge="end"
                    aria-label="delete"
                    sx={{ color: colors.grey[800] }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            }
          >
            <ListItemButton
              onClick={() => { }}
              sx={{ cursor: 'default' }}
              disableRipple
            >
              <ListItemAvatar>
                <Avatar {...stringAvatar(skillAssessment.title)}>
                  <AssessmentIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={skillAssessment.title || ''}
                secondary={skillAssessment.description || ''}
                secondaryTypographyProps={{
                  marginRight: '100px',
                  noWrap: true,
                }}
              />
            </ListItemButton>
          </ListItem>
          <Divider />
        </div>
      ))}
    </List>
  )
}
